import { render } from "./App.vue?vue&type=template&id=9f8db9ce"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9f8db9ce&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__